import React from 'react'

import store from '../../../admin/store'

/**
 * Add schema to link if not exists
 *
 * @param link
 * @param addInstagram  - add instagram host to url?
 * @returns {string}
 */
export const getLink = (link, addInstagram = false) => {

    if (addInstagram) {
        return link.indexOf('https://www.instagram.com/explore/tags/') !== -1 ? link : `https://www.instagram.com/explore/tags/${link.replace('#', '')}/`
    }

    return (link.indexOf('://') === -1) ? 'http://' + link : link
}

/**
 * Return null if is text string null
 *
 * @param text
 * @returns {null}
 */
export const skipNull = text => text === 'NULL' ? null : text

/**
 * Return image element
 *
 * @param image
 * @param alt
 * @returns {XML}
 */
export const getImage = (image, alt, defaultStyle = {}) => {
    if (! image) {
        return <span/>
    }

    let path = image.hasOwnProperty('path') ? image.path : image.id + image.suffix

    if (path) {
        path = image.hasOwnProperty('path') ? image.path : window.APP_CONFIG.REACT_APP_IMAGE_STORAGE_URL + path
    } else {
        path = image
    }

    return <img src={path} alt={alt} style={defaultStyle} />
}

/**
 * Get document height
 *
 * @returns {number}
 */
export const getDocHeight = () => Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
)
/**
 * Set text to defined lines size
 *
 * @param lines
 * @param element
 */
export const truncateTextToLines = (lines, element) => {
    const truncateText = element.textContent

    const getLineHeight = element => {
        const lineHeight = window.getComputedStyle(element)['line-height']
        if (lineHeight === 'normal') {
            // fuck chrome
            return 1.16 * parseFloat(window.getComputedStyle(element)['font-size'])
        } else {
            return parseFloat(lineHeight)
        }
    }

    element.innerHTML = truncateText
    const truncateTextParts = truncateText.split(' ')
    const lineHeight = getLineHeight(element)

    while(lines * lineHeight < element.clientHeight) {
        truncateTextParts.pop()
        element.innerHTML = truncateTextParts.join(' ') + '...'
    }
}

export const getLocationName = (sportVenue, onlyName = false) => {
    let locationName = ''

    if (sportVenue.locations && sportVenue.locations.data) {
        const mainLocation = sportVenue.locations.data.filter(location => location.residence)[0]
        if (!mainLocation) {
            return ''
        }
        if (onlyName) {
            return mainLocation.name
        }
        locationName = mainLocation.formatted_address || mainLocation.street
    }

    return locationName
}

/**
 *
 * @param {int} sportVenue
 * @param {int} limit
 * @return {Promise}
 */
export function fetchEventsForSportVenueDetail(sportVenue, limit) {
    let {
        fetching,
        cursor,
    } = store.getState().app.events

    // no more events
    if (fetching || cursor === null) {
        return new Promise(resolve => resolve())
    }

    store.dispatch({
        type: 'TOGGLE_BUSY_SECTION',
        section: 'sportVenue',
    })

    return window.axios.get(window.APP_CONFIG.REACT_APP_API_URL + `api/events?include=locations,sports,organisingGroup.club,owner&system=${window.APP_CONFIG.REACT_APP_SYSTEM}`
        + `&sportFacility=${sportVenue}`
        + `&limit=${limit}`
        + '&startDate=' + moment().format('YYYY-MM-DD')
        + '&tz=' + moment.tz.guess()
        + '&publishable=true'
        + '&types=1,2,4,5,6,7'
    ).then(({ data }) => {
        store.dispatch({
            type: 'TOGGLE_BUSY_SECTION',
            section: 'sportVenue',
        })

        store.dispatch({
            type: 'EVENTS_FETCHED',
            events: data.data,
            meta: data.meta,
            reset: false,
        })
    })
}

export function getUrl(addr) {
    if (addr.indexOf('http://') === -1 && addr.indexOf('https://') === -1) {
        return 'http://' + addr
    }

    return addr
}
